
const name = 'filter-select';

export default class FilterSelect {

  constructor ($el) {

    this.$el = $el;
    this.listeners = [];
    this.name = $el.dataset.name;

    // whether this select field supports selection of multiple options
    this.multiple = $el.classList.contains(`${name}--checkbox`);

    // array of selected options
    this.value = [];

    // bind to inputs
    this.$select = $el.querySelector(`.${name}__select`);
    this.$options = [...$el.querySelectorAll(`.${name}__option-input`)];

    // collect labels
    this.allLabel = $el.dataset.labelAll;
    this.optionLabels = {};
    [...this.$select.childNodes].forEach($option => {
      this.optionLabels[$option.value] = $option.innerText;
    });

    // bind elements
    this.$dropdownLabel = $el.querySelector(`.${name}__dropdown-label`);

    // bind events
    this.$select.addEventListener('change',
      this.onSelectChange.bind(this, this.$select));
    this.$options.forEach($option =>
      $option.addEventListener('change',
        this.onOptionChange.bind(this, $option)));

    // initial value update
    const value = JSON.parse($el.dataset.value);
    this.setValue(value);
  }

  addChangeListener (listener) {

    if (this.listeners.indexOf(listener) === -1) {
      this.listeners.push(listener);
    }

    return this;
  }

  onSelectChange ($select, evt) {

    const selectedValue = this.$select.value;
    let value = this.value.slice();

    if (this.multiple) {

      // toggle option in value
      const index = this.value.indexOf(selectedValue);
      if (index === -1) {
        value.push(selectedValue);
      } else {
        value.splice(index, 1);
      }

      // reset select element to allow for the next selection
      this.$select.value = 'select';

    } else {

      // update value
      value = [selectedValue];
    }

    this.setValue(value);
  }

  onOptionChange ($option, evt) {

    // collect selected options
    let value =
      this.$options
        .filter($option => $option.checked)
        .map($option => $option.value);

    this.setValue(value);
  }

  getName () {

    return this.name;
  }

  getValue () {

    return this.value;
  }

  setValue (value, sender = null) {

    this.value = value;

    // update label
    this.$dropdownLabel.innerText =
      value.length > 0
        ? value.map(option => this.optionLabels[option]).join(', ')
        : this.allLabel;

    if (sender !== 'options') {

      // update checked options
      this.$options.forEach($option => {
        $option.checked = this.value.indexOf($option.value) !== -1;
      });
    }

    if (sender !== 'select') {

      // update select
      if (!this.multiple) {
        this.$select.value = this.value[0];
      }
    }

    // notify listeners
    this.listeners.forEach(listener => listener != sender && listener(this));
  }

  resetValue (sender = null) {

    if (this.multiple) {
      this.setValue([], sender);
    } else {
      this.setValue(['all'], sender);
    }
  }
}
